import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mark } from './ui/kit';
import { MARKS } from '../lib/marks';

interface PaymentCancelProps {
  onRetry?: () => void;
  returnUrl?: string;
}

export const PaymentCancel: React.FC<PaymentCancelProps> = ({ 
  onRetry, 
  // returnUrl = '/' 
}) => {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      // fnd-k1d.7: the self-serve /onboarding flow is gone. A cancelled
      // checkout now retries from the billing page, which is where the
      // live Stripe cancel_url returns anyway.
      navigate('/dashboard/billing');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        {/* An empty receipt spike — nothing was rung up. */}
        <Mark src={MARKS.receipts} size="lg" className="mx-auto mb-4" />

        <h1 className="text-2xl font-bold text-zinc-900 mb-2">Payment Cancelled</h1>
        
        <p className="text-zinc-600 mb-6">
          Your payment was cancelled. No charges were made to your account.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={handleRetry}
            className="w-full bg-accent text-white py-2 px-4 rounded-lg hover:bg-accent-dark transition-colors"
          >
            Try Again
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-zinc-200 text-zinc-800 py-2 px-4 rounded-lg hover:bg-zinc-300 transition-colors"
          >
            Return Home
          </button>
        </div>
        
        <div className="mt-6 pt-6 border-t border-zinc-200">
          <p className="text-sm text-zinc-500">
            Need help? Contact our support team at{' '}
            <a href="mailto:hello@foundlio.com" className="text-accent hover:underline">
              hello@foundlio.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;